exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".md-RichEditor-editor h1,\n.md-RichEditor-editor h2,\n.md-RichEditor-editor h3 {\n\tmargin: 1.2em 0;\n\tline-height: 1.2;\n}\n.md-RichEditor-editor h1{ font-size:1.6em; }\n.md-RichEditor-editor h2 { font-size:1.3em; }\n.md-RichEditor-editor h3 { font-size:1.1em;  }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/editor/draft/custom-medium-draft.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/editor/draft/custom-medium-draft.css
// module chunks = 0